import { Box, BoxProps } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

type FormBlockProps = BoxProps & {
  isLastItem?: boolean;
  title?: string;
};

const FormBlock = (props: FormBlockProps) => {
  const { children, isLastItem, title, ...rest } = props;
  const boxProps: BoxProps = {
    display: 'flex',
    flexDirection: 'column',
    gap: '24',
    ...rest,
  };
  if (!isLastItem) {
    boxProps.paddingBlockEnd = '24';
    boxProps.borderBlockEnd = '1px solid';
    boxProps.borderBlockEndColor = 'border/regular';
    boxProps.marginBlockEnd = '24';
  }
  return (
    <Box {...boxProps}>
      {!!title && (
        <Text as="h2" textStyle="heading/h3">
          {title}
        </Text>
      )}
      {children}
      {isLastItem}
    </Box>
  );
};

export default FormBlock;
